import { derived, writable } from 'svelte/store';
import { cloneDate, subtractDay, addDay, setContent, resourceBackgroundColor, resourceTextColor, bgEvent, createEventClasses, createEventContent, isFunction, toEventWithLocalDates, toViewWithLocalDates, helperEvent, task, keyEnter, rect, ancestor, repositionEvent, height, max, outsideEvent, toISOString, outsideRange, datesEqual, setPayload, toLocalDate, getWeekNumber, assign, createEventChunk, runReposition, limitToRange, eventIntersects, prepareEventChunks, debounce, btnTextMonth, themeView, intl } from '@kokoro-calendar/core';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { getContext, onMount, tick } from 'svelte';

function days(state) {
    return derived([state.date, state.firstDay, state.hiddenDays], ([$date, $firstDay, $hiddenDays]) => {
        let days = [];
        let day = cloneDate($date);
        let max = 7;
        // First day of week
        while (day.getUTCDay() !== $firstDay && max) {
            subtractDay(day);
            --max;
        }
        for (let i = 0; i < 7; ++i) {
            if (!$hiddenDays.includes(day.getUTCDay())) {
                days.push(cloneDate(day));
            }
            addDay(day);
        }

        return days;
    });
}

var root_1$2 = $.template(`<div role="columnheader"><span></span></div>`);
var root$5 = $.template(`<div><div role="row"></div> <div></div></div>`);

function Header($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_days = () => $.store_get(_days, '$_days', $$stores);
	const $_intlDayHeaderAL = () => $.store_get(_intlDayHeaderAL, '$_intlDayHeaderAL', $$stores);
	const $_intlDayHeader = () => $.store_get(_intlDayHeader, '$_intlDayHeader', $$stores);

	let {
		theme,
		_intlDayHeader,
		_intlDayHeaderAL,
		_days
	} = getContext('state');

	$.init();

	var div = root$5();
	var div_1 = $.child(div);

	$.each(div_1, 5, $_days, $.index, ($$anchor, day) => {
		var div_2 = root_1$2();
		var span = $.child(div_2);

		$.action(span, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayHeader().format($.get(day)));
		$.reset(div_2);

		$.template_effect(
			($0, $1) => {
				$.set_class(div_2, `${$theme().day ?? ''} ${$0 ?? ''}`);
				$.set_attribute(span, 'aria-label', $1);
			},
			[
				() => $theme().weekdays?.[$.get(day).getUTCDay()],
				() => $_intlDayHeaderAL().format($.get(day))
			],
			$.derived_safe_equal
		);

		$.append($$anchor, div_2);
	});

	$.reset(div_1);

	var div_3 = $.sibling(div_1, 2);

	$.reset(div);

	$.template_effect(() => {
		$.set_class(div, $theme().header);
		$.set_class(div_1, $theme().days);
		$.set_class(div_3, $theme().hiddenScroll);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_1$1 = $.template(`<article><!> <div></div> <!></article>`);

function Event($$anchor, $$props) {
	$.push($$props, true);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $eventBackgroundColor = () => $.store_get(eventBackgroundColor, '$eventBackgroundColor', $$stores);
	const $eventColor = () => $.store_get(eventColor, '$eventColor', $$stores);
	const $eventTextColor = () => $.store_get(eventTextColor, '$eventTextColor', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_iClasses = () => $.store_get(_iClasses, '$_iClasses', $$stores);
	const $eventClassNames = () => $.store_get(eventClassNames, '$eventClassNames', $$stores);
	const $_view = () => $.store_get(_view, '$_view', $$stores);
	const $displayEventEnd = () => $.store_get(displayEventEnd, '$displayEventEnd', $$stores);
	const $eventContent = () => $.store_get(eventContent, '$eventContent', $$stores);
	const $_intlEventTime = () => $.store_get(_intlEventTime, '$_intlEventTime', $$stores);
	const $eventDidMount = () => $.store_get(eventDidMount, '$eventDidMount', $$stores);
	const $eventAllUpdated = () => $.store_get(eventAllUpdated, '$eventAllUpdated', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $_popupDate = () => $.store_get(_popupDate, '$_popupDate', $$stores);
	const $dayMaxEvents = () => $.store_get(dayMaxEvents, '$dayMaxEvents', $$stores);
	const $_hiddenEvents = () => $.store_get(_hiddenEvents, '$_hiddenEvents', $$stores);
	const $eventClick = () => $.store_get(eventClick, '$eventClick', $$stores);
	const $eventMouseEnter = () => $.store_get(eventMouseEnter, '$eventMouseEnter', $$stores);
	const $eventMouseLeave = () => $.store_get(eventMouseLeave, '$eventMouseLeave', $$stores);
	const $eventWrapper = () => $.store_get(eventWrapper, '$eventWrapper', $$stores);

	const eventComponent = ($$anchor) => {
		var article = root_1$1();

		article.__click = function (...$$args) {
			($.get(onclick) || undefined)?.apply(this, $$args);
		};

		var event_handler = $.derived(() => $.get(onclick) && keyEnter($.get(onclick)));

		article.__keydown = function (...$$args) {
			$.get(event_handler)?.apply(this, $$args);
		};

		var event_handler_1 = $.derived(() => createHandler($eventMouseEnter(), $.get(display)));
		var event_handler_2 = $.derived(() => createHandler($eventMouseLeave(), $.get(display)));
		var event_handler_3 = $.derived(() => !helperEvent($.get(display)) && createDragHandler($_interaction()));

		article.__pointerdown = function (...$$args) {
			$.get(event_handler_3)?.apply(this, $$args);
		};

		var node = $.child(article);
		const expression = $.derived(() => createDragHandler($_interaction(), ['x', 'start']));

		$.component(node, () => $.get(SvelteComponent), ($$anchor, $$component) => {
			$$component($$anchor, {
				start: true,
				get event() {
					return $.get(event);
				},
				get onpointerdown() {
					return $.get(expression);
				}
			});
		});

		var div = $.sibling(node, 2);

		$.action(div, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(content));

		var node_1 = $.sibling(div, 2);
		const expression_1 = $.derived(() => createDragHandler($_interaction(), ['x', 'end']));

		$.component(node_1, () => $.get(SvelteComponent), ($$anchor, $$component) => {
			$$component($$anchor, {
				get event() {
					return $.get(event);
				},
				get onpointerdown() {
					return $.get(expression_1);
				}
			});
		});

		$.reset(article);
		$.bind_this(article, ($$value) => el = $$value, () => el);

		$.template_effect(() => {
			$.set_class(article, $.get(classes));
			$.set_attribute(article, 'style', $.get(style));
			$.set_attribute(article, 'role', $.get(onclick) ? 'button' : undefined);
			$.set_attribute(article, 'tabindex', $.get(onclick) ? 0 : undefined);
			$.set_class(div, $theme().eventBody);
		});

		$.event('mouseenter', article, function (...$$args) {
			$.get(event_handler_1)?.apply(this, $$args);
		});

		$.event('mouseleave', article, function (...$$args) {
			$.get(event_handler_2)?.apply(this, $$args);
		});

		$.append($$anchor, article);
	};

	let {
		dayMaxEvents,
		displayEventEnd,
		eventAllUpdated,
		eventBackgroundColor,
		eventTextColor,
		eventClick,
		eventColor,
		eventContent,
		eventClassNames,
		eventDidMount,
		eventWrapper,
		eventMouseEnter,
		eventMouseLeave,
		resources,
		theme,
		_view,
		_intlEventTime,
		_interaction,
		_iClasses,
		_hiddenEvents,
		_popupDate,
		_tasks
	} = getContext('state');

	let el;
	let margin = 1;
	let hidden = false;
	const event = $.derived(() => $$props.chunk.event);
	const display = $.derived(() => $.get(event).display);

	const style = $.derived(() => {
		// Class & Style
		let bgColor = $.get(event).backgroundColor || resourceBackgroundColor($.get(event), $resources()) || $eventBackgroundColor() || $eventColor();
		let txtColor = $.get(event).textColor || resourceTextColor($.get(event), $resources()) || $eventTextColor();
		let style = '';

		if (bgEvent($.get(display))) {
			style = `width:calc(${$$props.chunk.days * 100}% + ${$$props.chunk.days - 1}px);`;
		} else {
			let marginTop = margin;

			if ($.get(event)._margin) {
				// Force margin for helper events
				let [_margin, _dates] = $.get(event)._margin;

				if ($$props.chunk.date >= _dates[0] && $$props.chunk.date <= _dates.at(-1)) {
					marginTop = _margin;
				}
			}

			style = `width:calc(${$$props.chunk.days * 100}% + ${($$props.chunk.days - 1) * 7}px);` + `margin-top:${marginTop}px;`;
		}

		if (bgColor) {
			style += `background-color:${bgColor};`;
		}

		if (txtColor) {
			style += `color:${txtColor};`;
		}

		if (hidden) {
			style += 'visibility:hidden;';
		}

		style += $.get(event).styles.join(';');
		return style;
	});

	const classes = $.derived(() => [
		bgEvent($.get(display)) ? $theme().bgEvent : $theme().event,
		...$_iClasses()([], $.get(event)),
		...createEventClasses($eventClassNames(), $.get(event), $_view())
	].join(' '));

	// Content
	const $$d = $.derived(() => createEventContent($$props.chunk, $displayEventEnd(), $eventContent(), $theme(), $_intlEventTime(), $_view())),
		timeText = $.derived(() => $.get($$d)[0]),
		content = $.derived(() => $.get($$d)[1]);

	onMount(() => {
		if (isFunction($eventDidMount())) {
			$eventDidMount()({
				event: toEventWithLocalDates($.get(event)),
				timeText: $.get(timeText),
				el,
				view: toViewWithLocalDates($_view())
			});
		}
	});

	$.user_effect(async () => {
		await tick();

		if (isFunction($eventAllUpdated()) && !helperEvent($.get(display))) {
			task(() => $eventAllUpdated()({ view: toViewWithLocalDates($_view()) }), 'eau', _tasks);
		}
	});

	function createHandler(fn, display) {
		return !helperEvent(display) && isFunction(fn)
			? (jsEvent) => fn({
				event: toEventWithLocalDates($.get(event)),
				el,
				jsEvent,
				view: toViewWithLocalDates($_view())
			})
			: undefined;
	}

	function createDragHandler(interaction, resize) {
		return interaction.action
			? (jsEvent) => $_interaction().action.drag(
				$.get(event),
				jsEvent,
				resize,
				$$props.inPopup ? $_popupDate() : null,
				[
					rect(el).top - rect(ancestor(el, 1)).top,
					$$props.dates
				],
				$$props.chunk.zeroDuration
			)
			: undefined;
	}

	function reposition() {
		if (!el) {
			return;
		}

		margin = repositionEvent($$props.chunk, $$props.longChunks, height(el));

		if ($dayMaxEvents() === true) {
			hide();
		} else {
			hidden = false;
		}
	}

	function hide() {
		let dayEl = ancestor(el, 2);
		let h = height(dayEl) - height(dayEl.firstElementChild) - footHeight(dayEl);

		hidden = $$props.chunk.bottom > h;

		let update = false;

		// Hide or show the event throughout all days
		for (let date of $$props.chunk.dates) {
			let hiddenEvents = $_hiddenEvents()[date.getTime()];

			if (hiddenEvents) {
				let size = hiddenEvents.size;

				if (hidden) {
					hiddenEvents.add($$props.chunk.event);
				} else {
					hiddenEvents.delete($$props.chunk.event);
				}

				if (size !== hiddenEvents.size) {
					update = true;
				}
			}
		}

		if (update) {
			$.store_set(_hiddenEvents, $.proxy($_hiddenEvents()));
		}
	}

	function footHeight(dayEl) {
		let h = 0;

		for (let i = 0; i < $$props.chunk.days; ++i) {
			h = max(h, height(dayEl.lastElementChild));
			dayEl = dayEl.nextElementSibling;

			if (!dayEl) {
				break;
			}
		}

		return h;
	}

	// Onclick handler
	const onclick = $.derived(() => !helperEvent($.get(display)) && createHandler($eventClick(), $.get(display)));
	const SvelteComponent = $.derived(() => $_interaction().resizer);
	var fragment = $.comment();
	var node_2 = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_3 = $.first_child(fragment_1);

			var render_arg = $.derived_safe_equal(() => ({
				event: $.get(event),
				timeText: $.get(timeText),
				view: toViewWithLocalDates($_view()),
				children: eventComponent
			}));

			$.snippet(node_3, $eventWrapper, () => $.get(render_arg));
			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			eventComponent($$anchor);
		};

		$.if(node_2, ($$render) => {
			if (isFunction($eventWrapper())) $$render(consequent); else $$render(alternate, false);
		});
	}

	$.append($$anchor, fragment);

	var $$pop = $.pop({ reposition });

	$$cleanup();
	return $$pop;
}

$.delegate(['click', 'keydown', 'pointerdown']);

var root$4 = $.template(`<div><div><time></time> <a role="button" tabindex="0">&times;</a></div> <div></div></div>`);

function Popup($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_popupChunks = () => $.store_get(_popupChunks, '$_popupChunks', $$stores);
	const $_popupDate = () => $.store_get(_popupDate, '$_popupDate', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_intlDayPopover = () => $.store_get(_intlDayPopover, '$_intlDayPopover', $$stores);
	const $buttonText = () => $.store_get(buttonText, '$buttonText', $$stores);

	let {
		buttonText,
		theme,
		_interaction,
		_intlDayPopover,
		_popupDate,
		_popupChunks
	} = getContext('state');

	let el = $.mutable_state();
	let style = $.mutable_state('');

	function position() {
		let dayEl = ancestor($.get(el), 1);
		let bodyEl = ancestor(dayEl, 3);
		let popupRect = rect($.get(el));
		let dayRect = rect(dayEl);
		let bodyRect = rect(bodyEl);

		$.set(style, '');

		let left;

		if (popupRect.width >= bodyRect.width) {
			left = bodyRect.left - dayRect.left;

			let right = dayRect.right - bodyRect.right;

			$.set(style, $.get(style) + `right:${right}px;`);
		} else {
			left = (dayRect.width - popupRect.width) / 2;

			if (dayRect.left + left < bodyRect.left) {
				left = bodyRect.left - dayRect.left;
			} else if (dayRect.left + left + popupRect.width > bodyRect.right) {
				left = bodyRect.right - dayRect.left - popupRect.width;
			}
		}

		$.set(style, $.get(style) + `left:${left}px;`);

		let top;

		if (popupRect.height >= bodyRect.height) {
			top = bodyRect.top - dayRect.top;

			let bottom = dayRect.bottom - bodyRect.bottom;

			$.set(style, $.get(style) + `bottom:${bottom}px;`);
		} else {
			top = (dayRect.height - popupRect.height) / 2;

			if (dayRect.top + top < bodyRect.top) {
				top = bodyRect.top - dayRect.top;
			} else if (dayRect.top + top + popupRect.height > bodyRect.bottom) {
				top = bodyRect.bottom - dayRect.top - popupRect.height;
			}
		}

		$.set(style, $.get(style) + `top:${top}px;`);
	}

	function reposition() {
		// Skip the first call (el is not defined at this time)
		if ($.get(el)) {
			$.set(style, '');

			// Let chunks to update/mount then position the popup
			tick().then(() => {
				if ($_popupChunks().length) {
					position();
				} else {
					close();
				}
			});
		}
	}

	function close(e) {
		$.store_set(_popupDate, null);
	}

	function handlePointerDownOutside(e) {
		close();
		$_interaction().action?.noClick();
	}

	$.legacy_pre_effect(() => ($_popupChunks()), () => {
		if ($_popupChunks()) {
			// Fire reposition only on popup chunks change
			reposition();
		}
	});

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$4();
	var div_1 = $.child(div);
	var time = $.child(div_1);

	$.action(time, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayPopover().format($_popupDate()));

	var a = $.sibling(time, 2);
	var event_handler = $.derived(() => keyEnter(close));

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);

	$.each(div_2, 5, $_popupChunks, (chunk) => chunk.event, ($$anchor, chunk) => {
		Event($$anchor, {
			get chunk() {
				return $.get(chunk);
			},
			inPopup: true
		});
	});

	$.reset(div_2);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));
	$.action(div, ($$node, $$action_arg) => outsideEvent?.($$node, $$action_arg), () => 'pointerdown');

	$.effect(() => $.event('pointerdown', div, $.stopPropagation(function ($$arg) {
		$.bubble_event.call(this, $$props, $$arg);
	})));

	$.effect(() => $.event('pointerdownoutside', div, handlePointerDownOutside));

	$.template_effect(
		($0) => {
			$.set_class(div, $theme().popup);
			$.set_attribute(div, 'style', $.get(style));
			$.set_class(div_1, $theme().dayHead);
			$.set_attribute(time, 'datetime', $0);
			$.set_attribute(a, 'aria-label', $buttonText().close);
			$.set_class(div_2, $theme().events);
		},
		[() => toISOString($_popupDate(), 10)],
		$.derived_safe_equal
	);

	$.event('click', a, $.stopPropagation(close));

	$.event('keydown', a, function (...$$args) {
		$.get(event_handler)?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root_1 = $.template(`<span></span>`);
var root_5 = $.template(`<div><!></div>`);
var root_6 = $.template(`<div><!></div>`);
var root_4 = $.template(`<!> <!>`, 1);
var root_10 = $.template(`<a role="button" tabindex="0" aria-haspopup="true"></a>`);
var root$3 = $.template(`<div role="cell"><div><time></time> <!></div> <div><!></div> <!> <div><!></div> <!> <div><!></div></div>`);

function Day($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $_hiddenEvents = () => $.store_get(_hiddenEvents, '$_hiddenEvents', $$stores);
	const $_today = () => $.store_get(_today, '$_today', $$stores);
	const $currentDate = () => $.store_get(currentDate, '$currentDate', $$stores);
	const $highlightedDates = () => $.store_get(highlightedDates, '$highlightedDates', $$stores);
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $moreLinkContent = () => $.store_get(moreLinkContent, '$moreLinkContent', $$stores);
	const $_popupDate = () => $.store_get(_popupDate, '$_popupDate', $$stores);
	const $weekNumbers = () => $.store_get(weekNumbers, '$weekNumbers', $$stores);
	const $firstDay = () => $.store_get(firstDay, '$firstDay', $$stores);
	const $weekNumberContent = () => $.store_get(weekNumberContent, '$weekNumberContent', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	const $_interaction = () => $.store_get(_interaction, '$_interaction', $$stores);
	const $_intlDayCell = () => $.store_get(_intlDayCell, '$_intlDayCell', $$stores);
	let date = $.prop($$props, 'date', 8);
	let chunks = $.prop($$props, 'chunks', 8);
	let bgChunks = $.prop($$props, 'bgChunks', 8);
	let longChunks = $.prop($$props, 'longChunks', 8);
	let iChunks = $.prop($$props, 'iChunks', 24, () => []);
	let dates = $.prop($$props, 'dates', 8);

	let {
		date: currentDate,
		dayMaxEvents,
		highlightedDates,
		firstDay,
		moreLinkContent,
		theme,
		validRange,
		weekNumbers,
		weekNumberContent,
		_hiddenEvents,
		_intlDayCell,
		_popupDate,
		_popupChunks,
		_today,
		_interaction
	} = getContext('state');

	let el = $.mutable_state();

	let dayChunks = $.mutable_state(),
		dayBgChunks = $.mutable_state();

	let isToday = $.mutable_state(),
		otherMonth = $.mutable_state(),
		highlight = $.mutable_state(),
		disabled = $.mutable_state();

	let hiddenEvents = $.mutable_state(new Set()); // hidden events of this day
	let moreLink = $.mutable_state('');
	let showPopup = $.mutable_state();
	let showWeekNumber = $.mutable_state();
	let weekNumber = $.mutable_state();
	let refs = $.mutable_state([]);

	function showMore() {
		$.store_set(_popupDate, date());
	}

	function setPopupChunks() {
		let nextDay = addDay(cloneDate(date()));
		let chunks = $.get(dayChunks).concat(longChunks()[date().getTime()]?.chunks || []);

		$.store_set(_popupChunks, chunks.map((chunk) => assign({}, chunk, createEventChunk(chunk.event, date(), nextDay), { days: 1, dates: [date()] })).sort((a, b) => a.top - b.top));
	}

	function reposition() {
		if (!$.get(disabled)) {
			runReposition($.get(refs), $.get(dayChunks));
		}
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$validRange()
		),
		() => {
			$.set(disabled, outsideRange(date(), $validRange()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(disabled),
			$.get(dayChunks),
			$.deep_read_state(bgChunks()),
			$.deep_read_state(date()),
			$.get(hiddenEvents),
			$.deep_read_state(chunks())
		),
		() => {
			if (!$.get(disabled)) {
				$.set(dayChunks, []);
				$.set(dayBgChunks, bgChunks().filter((bgChunk) => datesEqual(bgChunk.date, date())));
				$.get(hiddenEvents).clear();
				$.set(hiddenEvents, $.get(hiddenEvents));

				for (let chunk of chunks()) {
					if (datesEqual(chunk.date, date())) {
						$.get(dayChunks).push(chunk); // if ($dayMaxEvents !== false && dayChunks.length > $dayMaxEvents) {
					}
				}
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$.get(hiddenEvents)
		),
		() => {
			$.store_mutate(_hiddenEvents, $.untrack($_hiddenEvents)[date().getTime()] = $.get(hiddenEvents), $.untrack($_hiddenEvents));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$_today()
		),
		() => {
			$.set(isToday, datesEqual(date(), $_today()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(date()),
			$currentDate()
		),
		() => {
			$.set(otherMonth, date().getUTCMonth() !== $currentDate().getUTCMonth());
		}
	);

	$.legacy_pre_effect(
		() => (
			$highlightedDates(),
			$.deep_read_state(date())
		),
		() => {
			$.set(highlight, $highlightedDates().some((d) => datesEqual(d, date())));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(disabled),
			$_hiddenEvents(),
			$.get(hiddenEvents),
			$moreLinkContent(),
			isFunction
		),
		() => {
			if (!$.get(disabled) && $_hiddenEvents() && $.get(hiddenEvents).size) {
				// make Svelte update this block on $_hiddenEvents update
				let text = '+' + $.get(hiddenEvents).size + ' more';

				if ($moreLinkContent()) {
					$.set(moreLink, isFunction($moreLinkContent()) ? $moreLinkContent()({ num: $.get(hiddenEvents).size, text }) : $moreLinkContent());
				} else {
					$.set(moreLink, text);
				}
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$_popupDate(),
			$.deep_read_state(date())
		),
		() => {
			$.set(showPopup, $_popupDate() && datesEqual(date(), $_popupDate()));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(showPopup),
			$.deep_read_state(longChunks()),
			$.get(dayChunks),
			tick
		),
		() => {
			if ($.get(showPopup) && longChunks() && $.get(dayChunks)) {
				// Let chunks to reposition then set popup chunks
				tick().then(setPopupChunks);
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(el),
			$.deep_read_state(date()),
			$.get(disabled)
		),
		() => {
			if ($.get(el)) {
				setPayload($.get(el), () => ({
					allDay: true,
					date: date(),
					resource: undefined,
					dayEl: $.get(el),
					disabled: $.get(disabled)
				}));
			}
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(showWeekNumber),
			$weekNumbers(),
			$.deep_read_state(date()),
			$firstDay(),
			$weekNumberContent(),
			toLocalDate
		),
		() => {
			$.set(showWeekNumber, $weekNumbers() && date().getUTCDay() == ($firstDay() ? 1 : 0));

			if ($.get(showWeekNumber)) {
				let week = getWeekNumber(date(), $firstDay());

				if ($weekNumberContent()) {
					$.set(weekNumber, isFunction($weekNumberContent()) ? $weekNumberContent()({ date: toLocalDate(date()), week }) : $weekNumberContent());
				} else {
					$.set(weekNumber, 'W' + String(week).padStart(2, '0'));
				}
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$3();
	var div_1 = $.child(div);
	var time = $.child(div_1);

	$.action(time, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $_intlDayCell().format(date()));

	var node = $.sibling(time, 2);

	{
		var consequent = ($$anchor) => {
			var span = root_1();

			$.action(span, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(weekNumber));
			$.template_effect(() => $.set_class(span, $theme().weekNumber));
			$.append($$anchor, span);
		};

		$.if(node, ($$render) => {
			if ($.get(showWeekNumber)) $$render(consequent);
		});
	}

	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_1 = $.child(div_2);

	{
		var consequent_1 = ($$anchor) => {
			var fragment = $.comment();
			var node_2 = $.first_child(fragment);

			$.each(node_2, 1, () => $.get(dayBgChunks), (chunk) => chunk.event, ($$anchor, chunk) => {
				Event($$anchor, {
					get chunk() {
						return $.get(chunk);
					}
				});
			});

			$.append($$anchor, fragment);
		};

		$.if(node_1, ($$render) => {
			if (!$.get(disabled)) $$render(consequent_1);
		});
	}

	$.reset(div_2);

	var node_3 = $.sibling(div_2, 2);

	{
		var consequent_4 = ($$anchor) => {
			var fragment_2 = root_4();
			var node_4 = $.first_child(fragment_2);

			{
				var consequent_2 = ($$anchor) => {
					var div_3 = root_5();
					var node_5 = $.child(div_3);

					Event(node_5, {
						get chunk() {
							return iChunks()[2];
						}
					});

					$.reset(div_3);
					$.template_effect(() => $.set_class(div_3, $theme().events));
					$.append($$anchor, div_3);
				};

				$.if(node_4, ($$render) => {
					if (iChunks()[2] && datesEqual(iChunks()[2].date, date())) $$render(consequent_2);
				});
			}

			var node_6 = $.sibling(node_4, 2);

			{
				var consequent_3 = ($$anchor) => {
					var div_4 = root_6();
					var node_7 = $.child(div_4);

					Event(node_7, {
						get chunk() {
							return iChunks()[0];
						}
					});

					$.reset(div_4);
					$.template_effect(() => $.set_class(div_4, `${$theme().events ?? ''} ${$theme().preview ?? ''}`));
					$.append($$anchor, div_4);
				};

				$.if(node_6, ($$render) => {
					if (iChunks()[0] && datesEqual(iChunks()[0].date, date())) $$render(consequent_3);
				});
			}

			$.append($$anchor, fragment_2);
		};

		$.if(node_3, ($$render) => {
			if (!$.get(disabled)) $$render(consequent_4);
		});
	}

	var div_5 = $.sibling(node_3, 2);
	var node_8 = $.child(div_5);

	{
		var consequent_5 = ($$anchor) => {
			var fragment_3 = $.comment();
			var node_9 = $.first_child(fragment_3);

			$.each(node_9, 3, () => $.get(dayChunks), (chunk) => chunk.event, ($$anchor, chunk, i) => {
				$.bind_this(
					Event($$anchor, {
						get chunk() {
							return $.get(chunk);
						},
						get longChunks() {
							return longChunks();
						},
						get dates() {
							return dates();
						},
						$$legacy: true
					}),
					($$value, i) => $.mutate(refs, $.get(refs)[i] = $$value),
					(i) => $.get(refs)?.[i],
					() => [$.get(i)]
				);
			});

			$.append($$anchor, fragment_3);
		};

		$.if(node_8, ($$render) => {
			if (!$.get(disabled)) $$render(consequent_5);
		});
	}

	$.reset(div_5);

	var node_10 = $.sibling(div_5, 2);

	{
		var consequent_6 = ($$anchor) => {
			Popup($$anchor, {});
		};

		$.if(node_10, ($$render) => {
			if ($.get(showPopup)) $$render(consequent_6);
		});
	}

	var div_6 = $.sibling(node_10, 2);
	var node_11 = $.child(div_6);

	{
		var consequent_7 = ($$anchor) => {
			var a_1 = root_10();
			var event_handler = $.derived(() => keyEnter(showMore));

			$.effect(() => $.event('click', a_1, $.stopPropagation(showMore)));

			$.effect(() => $.event('keydown', a_1, function (...$$args) {
				$.get(event_handler)?.apply(this, $$args);
			}));

			$.effect(() => $.event('pointerdown', a_1, $.stopPropagation(function ($$arg) {
				$.bubble_event.call(this, $$props, $$arg);
			})));

			$.action(a_1, ($$node, $$action_arg) => setContent?.($$node, $$action_arg), () => $.get(moreLink));
			$.append($$anchor, a_1);
		};

		$.if(node_11, ($$render) => {
			if (!$.get(disabled) && $.get(hiddenEvents).size) $$render(consequent_7);
		});
	}

	$.reset(div_6);
	$.reset(div);
	$.bind_this(div, ($$value) => $.set(el, $$value), () => $.get(el));

	$.template_effect(
		($0, $1) => {
			$.set_class(div, `${$theme().day ?? ''} ${$0 ?? ''}${($.get(isToday) ? ' ' + $theme().today : '') ?? ''}${($.get(otherMonth) ? ' ' + $theme().otherMonth : '') ?? ''}${($.get(highlight) ? ' ' + $theme().highlight : '') ?? ''}${($.get(disabled) ? ' ' + $theme().disabled : '') ?? ''}`);
			$.set_class(div_1, $theme().dayHead);
			$.set_attribute(time, 'datetime', $1);
			$.set_class(div_2, $theme().bgEvents);
			$.set_class(div_5, $theme().events);
			$.set_class(div_6, $theme().dayFoot);
		},
		[
			() => $theme().weekdays?.[date().getUTCDay()],
			() => toISOString(date(), 10)
		],
		$.derived_safe_equal
	);

	$.event('pointerdown', div, function (...$$args) {
		$_interaction().action?.select?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.bind_prop($$props, 'reposition', reposition);

	var $$pop = $.pop({ reposition });

	$$cleanup();
	return $$pop;
}

var root$2 = $.template(`<div role="row"></div>`);

function Week($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $validRange = () => $.store_get(validRange, '$validRange', $$stores);
	const $_events = () => $.store_get(_events, '$_events', $$stores);
	const $filterEventsWithResources = () => $.store_get(filterEventsWithResources, '$filterEventsWithResources', $$stores);
	const $resources = () => $.store_get(resources, '$resources', $$stores);
	const $hiddenDays = () => $.store_get(hiddenDays, '$hiddenDays', $$stores);
	const $_iEvents = () => $.store_get(_iEvents, '$_iEvents', $$stores);
	const $_hiddenEvents = () => $.store_get(_hiddenEvents, '$_hiddenEvents', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);
	let dates = $.prop($$props, 'dates', 8);

	let {
		_events,
		_iEvents,
		_queue2,
		_hiddenEvents,
		resources,
		filterEventsWithResources,
		hiddenDays,
		theme,
		validRange
	} = getContext('state');

	let chunks = $.mutable_state(),
		bgChunks = $.mutable_state(),
		longChunks = $.mutable_state(),
		iChunks = $.mutable_state([]);

	let start = $.mutable_state();
	let end = $.mutable_state();
	let refs = $.mutable_state([]);
	let debounceHandle = {};

	function reposition() {
		debounce(() => runReposition($.get(refs), dates()), debounceHandle, _queue2);
	}

	$.legacy_pre_effect(
		() => (
			$.deep_read_state(dates()),
			$validRange(),
			cloneDate
		),
		() => {
			$.set(start, limitToRange(dates()[0], $validRange()));
			$.set(end, addDay(cloneDate(limitToRange(dates().at(-1), $validRange()))));
		}
	);

	$.legacy_pre_effect(
		() => (
			$.get(chunks),
			$.get(bgChunks),
			$_events(),
			$.get(start),
			$.get(end),
			$filterEventsWithResources(),
			$resources(),
			$hiddenDays()
		),
		() => {
			$.set(chunks, []);
			$.set(bgChunks, []);

			for (let event of $_events()) {
				if (eventIntersects(event, $.get(start), $.get(end), $filterEventsWithResources() ? $resources() : undefined)) {
					let chunk = createEventChunk(event, $.get(start), $.get(end));

					if (bgEvent(event.display)) {
						if (event.allDay) {
							$.get(bgChunks).push(chunk);
						}
					} else {
						$.get(chunks).push(chunk);
					}
				}
			}

			prepareEventChunks($.get(bgChunks), $hiddenDays());
			$.set(longChunks, prepareEventChunks($.get(chunks), $hiddenDays()));
			// Run reposition only when events get changed
			reposition();
		}
	);

	$.legacy_pre_effect(
		() => (
			$_iEvents(),
			$.get(start),
			$.get(end),
			$hiddenDays()
		),
		() => {
			$.set(iChunks, $_iEvents().map((event) => {
				let chunk;

				if (event && eventIntersects(event, $.get(start), $.get(end))) {
					chunk = createEventChunk(event, $.get(start), $.get(end));
					prepareEventChunks([chunk], $hiddenDays());
				} else {
					chunk = null;
				}

				return chunk;
			}));
		}
	);

	$.legacy_pre_effect(() => ($_hiddenEvents(), tick), () => {
		if ($_hiddenEvents()) {
			// Schedule reposition during next update
			tick().then(reposition);
		}
	});

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$2();

	$.event('resize', $.window, reposition);

	$.each(div, 5, dates, $.index, ($$anchor, date, i) => {
		$.bind_this(
			Day($$anchor, {
				get date() {
					return $.get(date);
				},
				get chunks() {
					return $.get(chunks);
				},
				get bgChunks() {
					return $.get(bgChunks);
				},
				get longChunks() {
					return $.get(longChunks);
				},
				get iChunks() {
					return $.get(iChunks);
				},
				get dates() {
					return dates();
				},
				$$legacy: true
			}),
			($$value, i) => $.mutate(refs, $.get(refs)[i] = $$value),
			(i) => $.get(refs)?.[i],
			() => [i]
		);
	});

	$.reset(div);
	$.template_effect(() => $.set_class(div, $theme().days));
	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root$1 = $.template(`<div><div></div></div>`);

function Body($$anchor, $$props) {
	$.push($$props, false);

	const [$$stores, $$cleanup] = $.setup_stores();
	const $hiddenDays = () => $.store_get(hiddenDays, '$hiddenDays', $$stores);
	const $dayMaxEvents = () => $.store_get(dayMaxEvents, '$dayMaxEvents', $$stores);
	const $_viewDates = () => $.store_get(_viewDates, '$_viewDates', $$stores);
	const $_bodyEl = () => $.store_get(_bodyEl, '$_bodyEl', $$stores);
	const $theme = () => $.store_get(theme, '$theme', $$stores);

	let {
		_bodyEl,
		_viewDates,
		_hiddenEvents,
		dayMaxEvents,
		hiddenDays,
		theme
	} = getContext('state');

	let weeks = $.mutable_state();
	let days = $.mutable_state();

	$.legacy_pre_effect(
		() => (
			$.get(weeks),
			$.get(days),
			$hiddenDays(),
			$dayMaxEvents(),
			$_viewDates()
		),
		() => {
			$.set(weeks, []);
			$.set(days, 7 - $hiddenDays().length);
			$.store_set(_hiddenEvents, {});
			$dayMaxEvents();

			for (let i = 0; i < $_viewDates().length / $.get(days); ++i) {
				let dates = [];

				for (let j = 0; j < $.get(days); ++j) {
					dates.push($_viewDates()[i * $.get(days) + j]);
				}

				$.get(weeks).push(dates);
			}
		}
	);

	$.legacy_pre_effect_reset();
	$.init();

	var div = root$1();
	var div_1 = $.child(div);

	$.each(div_1, 5, () => $.get(weeks), $.index, ($$anchor, dates) => {
		Week($$anchor, {
			get dates() {
				return $.get(dates);
			}
		});
	});

	$.reset(div_1);
	$.reset(div);
	$.bind_this(div, ($$value) => $.store_set(_bodyEl, $$value), () => $_bodyEl());

	$.template_effect(() => {
		$.set_class(div, `${$theme().body ?? ''}${($dayMaxEvents() === true ? ' ' + $theme().uniform : '') ?? ''}`);
		$.set_class(div_1, $theme().content);
	});

	$.append($$anchor, div);
	$.pop();
	$$cleanup();
}

var root = $.template(`<!> <!>`, 1);

function View($$anchor) {
	var fragment = root();
	var node = $.first_child(fragment);

	Header(node, {});

	var node_1 = $.sibling(node, 2);

	Body(node_1, {});
	$.append($$anchor, fragment);
}

var index = {
    createOptions(options) {
        options.dayMaxEvents = false;
        options.dayCellFormat = { day: 'numeric' };
        options.dayPopoverFormat = { month: 'long', day: 'numeric', year: 'numeric' };
        options.moreLinkContent = undefined;
        // Common options
        options.buttonText.dayGridMonth = 'month';
        options.buttonText.close = 'Close';
        options.theme.uniform = 'ec-uniform';
        options.theme.dayFoot = 'ec-day-foot';
        options.theme.popup = 'ec-popup';
        options.theme.weekNumber = 'ec-week-number';
        options.view = 'dayGridMonth';
        options.weekNumbers = false;
        options.weekNumberContent = undefined;
        options.views.dayGridMonth = {
            buttonText: btnTextMonth,
            component: View,
            dayHeaderFormat: { weekday: 'short' },
            dayHeaderAriaLabelFormat: { weekday: 'long' },
            displayEventEnd: false,
            duration: { months: 1 },
            theme: themeView('ec-day-grid ec-month-view'),
            titleFormat: { year: 'numeric', month: 'long' }
        };
    },

    createStores(state) {
        state._days = days(state);
        state._intlDayCell = intl(state.locale, state.dayCellFormat);
        state._intlDayPopover = intl(state.locale, state.dayPopoverFormat);
        state._hiddenEvents = writable({});
        state._popupDate = writable(null);
        state._popupChunks = writable([]);
    }
};

export { index as default };
